export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/cover_letters.be2136d.svg";